import { PigGender } from "../../domain/model/pig-gender.type";
import { Uuid } from "../../domain/model/uuid/uuid.type";
import { StoreUpdateInfo as UpdateInfoViewModel } from "../../storage/store-update-info";

export class BatchWeighingStoreCommand {

  constructor(
    readonly id: Uuid,
    readonly batchWeighingId: Uuid,
    readonly gender: PigGender,
    readonly updateInfo: UpdateInfoViewModel) { }
}
